import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import { getUrlForImage } from "../cubeComponent/constants/globalFunctions";
import { CONSTANTS } from "../cubeComponent/constants/globalVariable";
import axiosWrapper from "../services/axiosWrapper";
import type {
  GetUserDetailsResponse,
  CheckIfAuthenticatedResponse,
  InitiateSignupEmailVerificationResponse,
} from "@ServerTypes/accounts/accounts.schema";
import { setUserDetails } from "../reducers/userDetailsSlice";
import { setCheckIfAuthenticated } from "../reducers/authentication";
import { clearCsrfToken } from "@Services/axiosShared";

const saveUserDetails = setUserDetails;

export function getUserDetails() {
  return (dispatch: AppDispatch) => {
    axiosWrapper.get<GetUserDetailsResponse>(`${getBackendUrl()}/accounts/getUserDetails`).then(async (response) => {
      const res = response?.data.status ? (response.data as any).data?.[0] : null;
      if (res) {
        let data = {
          ...res,
          lastName: res.lastName ? res.lastName : "",
          profilePicUrl: res.profilePic ? getUrlForImage(res) : "",
          company: {
            ...res.company,
            logoUrl: res.company?.logo ? getUrlForImage(res.company, CONSTANTS.ORGANIZATION) : "",
          },
          // portal: {
          //   ...res.portal,
          //   logoUrl: res?.portal?.logo ? getUrlForImage(res.portal, CONSTANTS.PORTAL) : '',
          // },
          signatureUrl: res.signature
            ? `${getBackendUrl()}/fileSystemServer/getSignDocs/${res.signature}?${Date.now()}`
            : "",
          messageFooterContent: res.messageFooter ?? "",
          status: true,
        };
        (window as any).electronAPI?.setUserDataInDesktop?.(data);
        dispatch(saveUserDetails(data));
      } else {
        dispatch(saveUserDetails({ status: false }));
      }
    });
  };
}

export async function initiateSignupEmailVerification(email: string) {
  return await axiosWrapper.post<InitiateSignupEmailVerificationResponse>(
    `${getBackendUrl()}/accounts/initiateSignupEmailVerification`,
    {
      email,
    },
  );
}

export function getCheckIfAuthenticated() {
  return (dispatch: AppDispatch) => {
    axiosWrapper
      .get<CheckIfAuthenticatedResponse>(`${getBackendUrl()}/accounts/checkIfAuthenticated`, {
        withCredentials: true,
      })
      .then((response) => {
        clearCsrfToken();
        dispatch(setCheckIfAuthenticated({ data: response.data }));
        return response.data;
      });
  };
}
